import React, { useState } from 'react'
import Cleave from 'cleave.js/react'
import styles from '../../Modals/Modal.module.css'
import customStyle from './style.module.css'
import logoPacifico from '../../../img/pacifico-logo-2.png'
import niubiz from '../../../img/niubiz-gray.png'

const Modal = (props) => {
    const [typeCard, setTypeCard] = useState('')
    const {mostrarModal, setModal} = props;

    function cerrarModal(data) {
        setModal(data)
    }

    const getIconCard = () => {
        switch (typeCard) {
            default:
                return ''
        }
    }

    return (
        <div>
            <div className={mostrarModal ? `${styles['w3-modal']} ${styles['show-modal-beneficiaries']}` : `${styles['w3-modal']} ${styles['hide-modal-beneficiaries']}`}>
                <div className={`${styles['w3-modal-content']} ${customStyle.contentWidth}`}>
                    <div className={styles['w3-header']}>
                    </div>
                    <div className={styles['w3-container']}>
                        <div className={customStyle.headLogo}>
                            <img alt='yy' src={logoPacifico} />
                        </div>
                        <div className={customStyle.formPayment}>
                            <div className={customStyle.formPayment__row}>
                                <Cleave
                                    className={customStyle['formPayment__row--icon']}
                                    options={{
                                        creditCard: true,
                                        delimiter: '-',
                                        onCreditCardTypeChanged: function (type) {
                                            setTypeCard(type)
                                        }
                                    }}
                                    onChange={(e) => console.info(e.target.value)}
                                    placeholder='Número de Tarjeta'
                                />
                                {getIconCard()}
                            </div>
                            <div className={customStyle.formPayment__row}>
                                <Cleave
                                    className={`${customStyle.formPayment__col} ${customStyle['formPayment__col--left']} ${customStyle['formPayment__row--icon']}`}
                                    options={{
                                        date: true,
                                        datePattern: ['m', 'Y']
                                    }}
                                    placeholder='MM/YYYY'
                                    onChange={(e) => console.info(e.target.value)}
                                />
                                <Cleave
                                    className={`${customStyle.formPayment__col} ${customStyle['formPayment__col--right']} ${customStyle['formPayment__row--icon']}`}
                                    options={{
                                        numeral: true,
                                        blocks: [3],
                                    }}
                                    placeholder='CVV'
                                    maxLength='3'
                                    onChange={(e) => console.info(e.target.value)}
                                />
                            </div>
                            <button className={customStyle['formPayment--btn']}>Pagar $63.00</button>
                            <div className={customStyle['formPayment--niubiz']}>
                                <img alt='rr' src={niubiz} />
                            </div>
                        </div>
                        <div className={styles['w3areabtn']}>
                            <button className={`${customStyle['btn-pago-cancel']}`} onClick = {()=>cerrarModal(false)}>
                                Cancelar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Modal;